const comments = [
  {
    name: '深夜影迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Dark%20minimalist%20portrait%20of%20a%20young%20person%20with%20warm%20soft%20side%20lighting%20on%20a%20dark%20background%2C%20half%20face%20in%20shadow%2C%20contemplative%20expression%2C%20cinematic%20portrait%20photography%2C%20noir%20style%2C%20rich%20contrast&width=160&height=160&seq=avatar-user-01&orientation=squarish',
    role: '资深影迷',
    content: '每天晚上睡前必刷夜猫影院！最近在追悬疑片单，烧脑又过瘾。高清不卡顿这个真不是吹的，比我用过的其他电影大全免费平台都稳定，强烈推荐给所有深夜追剧的朋友。',
    rating: 5,
    date: '2026-07-30',
  },
  {
    name: '电影发烧友阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Dark%20moody%20portrait%20of%20a%20young%20adult%20with%20dramatic%20single%20light%20source%20from%20above%2C%20sharp%20shadows%20on%20face%2C%20artistic%20noir%20portrait%20photography%2C%20intense%20and%20thoughtful%20expression%2C%20rich%20dark%20tones&width=160&height=160&seq=avatar-user-02&orientation=squarish',
    role: '电影博主',
    content: '作为一个写了三年影评的电影博主，夜猫影院的片源质量和更新速度让我很惊喜。尤其是热门电影推荐板块，编辑选片的品味很在线，国产和海外都有覆盖，深夜写稿的最佳伴侣。',
    rating: 5,
    date: '2026-07-28',
  },
  {
    name: '追剧不停的小美',
    avatar: 'https://readdy.ai/api/search-image?query=Soft%20cinematic%20portrait%20of%20a%20person%20with%20gentle%20warm%20lighting%20from%20a%20window%2C%20relaxed%20and%20happy%20expression%2C%20dark%20background%2C%20artistic%20portrait%20photography%2C%20rich%20and%20inviting%20atmosphere&width=160&height=160&seq=avatar-user-03&orientation=squarish',
    role: '忠实用户',
    content: '无意间发现夜猫影院后就成了铁粉！全免费真的太良心了，而且不需要注册就能看，懒人福音。最近刚追完流浪地球3，4K画质在大屏上看简直震撼，已安利给身边所有朋友。',
    rating: 5,
    date: '2026-07-25',
  },
];

export default function SectionComments() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-500/10 border border-secondary-500/20 mb-4">
            <span className="w-3 h-3 flex items-center justify-center"><i className="ri-chat-quote-fill text-secondary-400 text-xs"></i></span>
            <span className="text-xs text-secondary-400 font-medium whitespace-nowrap">用户口碑</span>
          </div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-50 mb-2">观众评价</h2>
          <p className="text-sm text-foreground-400 max-w-lg mx-auto">来自深夜影迷的真实反馈，每一句都是夜猫前行的动力</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 max-w-4xl mx-auto">
          {comments.map((c) => (
            <div
              key={c.name}
              className="flex flex-col p-5 rounded-lg bg-background-50 border border-background-200/50"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img src={c.avatar} alt={c.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-100">{c.name}</p>
                  <p className="text-[10px] text-foreground-500">{c.role} · {c.date}</p>
                </div>
              </div>
              <div className="flex gap-0.5 mb-2">
                {Array.from({ length: c.rating }).map((_, i) => (
                  <span key={i} className="w-3 h-3 flex items-center justify-center"><i className="ri-star-fill text-primary-400 text-xs"></i></span>
                ))}
              </div>
              <p className="text-xs text-foreground-300 leading-relaxed flex-1">{c.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}